import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Facilities from "./pages/Facilities";
import HowItWorks from "./pages/HowItWorks";
import MachineMarketplace from "./pages/MachineMarketplace";



import UserLayout from "./Users/layouts/UserLayout";
import Dashboard from "./Users/pages/Dashboard";
import MyProjects from "./Users/pages/MyProjects";
import NewPrototype from "./Users/pages/NewPrototype";
import UserFacilities from "./Users/pages/Facilities";
import Machines from "./Users/pages/Machines";
import Experts from "./Users/pages/Experts";
import Quotations from "./Users/pages/Quotations";
import Orders from "./Users/pages/Orders";
import Payments from "./Users/pages/Payments";
import Documents from "./Users/pages/Documents";
import Messages from "./Users/pages/Messages";
import Help from "./Users/pages/Help";
import Promotions from "./Users/pages/Promotions";




import AdminDashboard from "./admin/AdminDashboard";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/facilities" element={<Facilities />} />
        <Route path="/howitworks" element={<HowItWorks />} />
        <Route path="/machinemarketplace" element={<MachineMarketplace />} />


        <Route path="/app" element={<UserLayout />}>
          {/* dashboard, projects, bookings, quotations... will go here as children */}
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="projects" element={<MyProjects />} />
          <Route path="new-prototype" element={<NewPrototype />} />
          <Route path="facilities" element={<UserFacilities />} /> {/* Added this line */}
          <Route path="machines" element={<Machines />} />
          <Route path="facilities/:city/machines" element={<Machines />} />
          <Route path="experts" element={<Experts />} />
          <Route path="quotations" element={<Quotations />} />
          <Route path="orders" element={<Orders />} />
          <Route path="payments" element={<Payments />} />
          <Route path="documents" element={<Documents />} />
          <Route path="messages" element={<Messages />} />
          <Route path="help" element={<Help />} />
          <Route path="promotions" element={<Promotions />} />
        </Route>


        <Route path="/admin/*" element={<AdminDashboard />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;